import { Icons } from "../../../components/atoms/icon";

/**
 * @constant
 * @type {Object}
 * @property {string} TROUBLESHOOTING_OBJECT_ID - トラブルシューティングのカテゴリID
 * @property {string} TEMPLATE_OBJECT_ID - テンプレートのカテゴリID
 * @property {string} BEGINNER_GUIDE_OBJECT_ID - はじめて使う方向けガイドのカテゴリID
 * @property {string} TRAINING_OBJECT_ID - 操作研修（研修資料・アーカイブ動画）のカテゴリID
 * @property {string} NEW_FUNCTION_OBJECT_ID - 事例・オプジョン新機能紹介（研修資料・アーカイブ動画）のカテゴリID
 * @property {string} VIDEO_OBJECT_ID - 操作説明動画のカテゴリID
 * @property {string} SEARCH_FUNCTION_OBJECT_ID - 機能・使い方で調べるのカテゴリID
 * @property {string} RELEASE_NOTE_OBJECT_ID - リリースノートのカテゴリID
 * @property {string} PRODUCT_INFORMATION_OBJECT_ID - プロダクト活用お役立ち情報のカテゴリID
 * @property {string} PAID_OPTION_OBJECT_ID - 有料オプションのカテゴリID
 * @property {string} SECURITY_OBJECT_ID - セキュリティのカテゴリID
 * @property {string} CONTRACT_OBJECT_ID - 料金や契約内容・契約更新のカテゴリID
 * @property {string} SUPPORT_OBJECT_ID - サポートのカテゴリID
 * @property {string} MAIL_LETTER_OBJECT_ID - メールレターのカテゴリID
 * @property {string} GOVTECH_TRENDS_OBJECT_ID - GovtechTrendsのカテゴリID
 */
export const CategoryObjectIds = {
  NOTIFICATION_OBJECT_ID: "66fe28789479f9cec06c0650",
  TROUBLESHOOTING_OBJECT_ID: "66d6a59725a33cd032f0706a",
  TEMPLATE_OBJECT_ID: "66daab9c25a33cd032f0787f",
  BEGINNER_GUIDE_OBJECT_ID: "66c4461b1c372de233c17667",
  TRAINING_OBJECT_ID: "66bc6b7e8952807888256982",
  NEW_FUNCTION_OBJECT_ID: "66daad7c25a33cd032f07882",
  VIDEO_OBJECT_ID: "66daae1925a33cd032f07886",
  SEARCH_FUNCTION_OBJECT_ID: "66cd40231c372de233c183a1",
  RELEASE_NOTE_OBJECT_ID: "66cecfad5c298dfbab4c50c2",
  PRODUCT_INFORMATION_OBJECT_ID: "66ced00c5c298dfbab4c50c5",
  PAID_OPTION_OBJECT_ID: "66d7fd4f25a33cd032f07300",
  SECURITY_OBJECT_ID: "66d7fd7825a33cd032f07303",
  CONTRACT_OBJECT_ID: "66d7fde525a33cd032f07307",
  SUPPORT_OBJECT_ID: "66d7fe2125a33cd032f0730a",
  MAIL_LETTER_OBJECT_ID: "66d7fe5b25a33cd032f0730d",
  GOVTECH_TRENDS_OBJECT_ID: "66d7feb525a33cd032f07311",
} as const;

export const HelpIcon: {
  [key: string]: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & { title?: string }
  >;
} = {
  // トラブルシューティングのカテゴリID
  [CategoryObjectIds.TROUBLESHOOTING_OBJECT_ID]: Icons.QuestionCircleIcon,
  // テンプレートのカテゴリID
  [CategoryObjectIds.TEMPLATE_OBJECT_ID]: Icons.SmartApplyIcon,
  // はじめて使う方向けガイドのカテゴリID
  [CategoryObjectIds.BEGINNER_GUIDE_OBJECT_ID]: Icons.TutorialIcon,
  // 操作研修（研修資料・アーカイブ動画）のカテゴリID
  [CategoryObjectIds.TRAINING_OBJECT_ID]: Icons.PcIcon,
  // 事例・オプジョン新機能紹介（研修資料・アーカイブ動画）のカテゴリID
  [CategoryObjectIds.NEW_FUNCTION_OBJECT_ID]: Icons.PaperIcon,
  // 操作説明動画のカテゴリID
  [CategoryObjectIds.VIDEO_OBJECT_ID]: Icons.StartCircleIcon,
  // 機能・使い方で調べるのカテゴリID
  [CategoryObjectIds.SEARCH_FUNCTION_OBJECT_ID]: Icons.SettingIcon,
  // リリースノートのカテゴリID
  [CategoryObjectIds.RELEASE_NOTE_OBJECT_ID]: Icons.AnnouncementIcon,
  // プロダクト活用お役立ち情報のカテゴリID
  [CategoryObjectIds.PRODUCT_INFORMATION_OBJECT_ID]: Icons.CommentIcon,
  // 有料オプションのカテゴリID
  [CategoryObjectIds.PAID_OPTION_OBJECT_ID]: Icons.PlusCircleIcon,
  // セキュリティのカテゴリID
  [CategoryObjectIds.SECURITY_OBJECT_ID]: Icons.SecurityIcon,
  // 料金や契約内容・契約更新のカテゴリID
  [CategoryObjectIds.CONTRACT_OBJECT_ID]: Icons.ListSettingIcon,
  // サポートのカテゴリID
  [CategoryObjectIds.SUPPORT_OBJECT_ID]: Icons.InfoCircleIcon,
  // メールレターのカテゴリID
  [CategoryObjectIds.MAIL_LETTER_OBJECT_ID]: Icons.MailIcon,
  // GovtechTrendsのカテゴリID
  [CategoryObjectIds.GOVTECH_TRENDS_OBJECT_ID]: Icons.BookmarkIcon,
} as const;
